import React from 'react';
import {
  Card,
  CardActions,
  CardContent,
  Divider,
  Typography,
} from '@mui/material';
import {bool, func, number, object} from 'prop-types';
import {useTranslation} from 'react-i18next';

import {ChipAndLabel} from './ChipAndLabel.jsx';
import {formatArea} from '../format.js';

export const CandidateChooser = ({
  candidate,
  selected,
  originalArea,
  onChange,
}) => {
  const {t} = useTranslation();

  return (
    <Card
      raised={selected}
      onClick={() => {
        onChange(candidate);
      }}
      sx={{
        cursor: 'pointer',
        marginBottom: 2,
        border: '1px solid',
        borderColor: selected ? 'primary.main' : 'transparent',
      }}
    >
      <CardContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          margin: 0,
          paddingTop: 1,
          minHeight: 100,
          '&:last-child': {paddingBottom: 0},
          backgroundColor: selected ? 'primary.lighter' : undefined,
        }}
      >
        <Typography variant="subtitle2" gutterBottom>
          {t(candidate.label)}
        </Typography>
        <Typography
          variant="caption"
          color="textSecondary"
          component="div"
          sx={{flex: 1}}
        >
          {t(candidate.description)}
        </Typography>
      </CardContent>
      <Divider />
      <CardActions
        sx={{backgroundColor: selected ? 'primary.lighter' : undefined}}
      >
        <ChipAndLabel
          color="primary"
          label={
            <>
              Original area: <b>{formatArea(originalArea)}</b>
            </>
          }
          sx={{flex: 1}}
        />
        <ChipAndLabel
          color="secondary"
          label={
            <>
              Proposed: <b>{formatArea(candidate.area)}</b>
            </>
          }
          sx={{flex: 1, justifyContent: 'right'}}
        />
      </CardActions>
    </Card>
  );
};

CandidateChooser.propTypes = {
  candidate: object,
  onChange: func,
  selected: bool,
  originalArea: number,
};
